import api from './axiosConfig';

export const customerApi = {
  getCustomers: () => api.get('/v1/customers'),
  getCustomerDetails: (id) => api.get(`/v1/customers/${id}`),
  addCustomer: (data) => api.post('/v1/customers', data),
  sendReminder: (id) => api.post(`/v1/customers/${id}/remind`),
};
